"use client";
import { useSearchParams } from "react-router-dom";
import Header from "../../../components/admin/common/Header";
import PageWrapper from "../../../components/admin/common/PageWrapper";
import Sidebar from "../../../components/admin/common/Sidebar";
import EditNewsForm from "../../../components/admin/news/EditNewsForm";
import { useEffect, useState } from "react";
import { getNewsById } from "../../../services/newsServices";

const EditNews = () => {
  const [searchParams] = useSearchParams();
  const newsId = searchParams.get("newsId");
  const [news, setNews] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!newsId) return;

    const fetchNews = async () => {
      try {
        setLoading(true);
        const data = await getNewsById(newsId);
        setNews(data.data);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, [newsId]);

  const handleGoBack = () => {
    window.location.href = "/admin/news/list";
  };

  return (
    <div className="flex h-screen p-4 gap-4 bg-white overflow-hidden">
      {/* Sidebar */}
      <div className="h-full">
        <div className="sticky top-0 h-screen text-white">
          <Sidebar />
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 h-full bg-[#F3EFFF] rounded-[27px] overflow-hidden">
        <PageWrapper>
          <div className="flex flex-col h-full">
            <div className="flex-1 p-4 overflow-y-auto w-full">
              <div className="flex items-start w-full gap-2">
                <button
                  onClick={handleGoBack}
                  className="flex items-center justify-center w-10 h-10 rounded-full bg-white shadow-sm hover:shadow-md transition-shadow"
                  title="Go back"
                >
                  <span className="text-gray-600 text-lg">←</span>
                </button>{" "}
                <Header title="Edit News" desc="Here u can edit the news" />
              </div>

              {loading && <p>Loading...</p>}
              <EditNewsForm news={news} id={newsId} />
            </div>
          </div>
        </PageWrapper>
      </div>
    </div>
  );
};

export default EditNews;
